/**
 * StatusCarga
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {StatusCargaCollection} from '@/model/collection/StatusCargaCollection'

/* TODO: review generated class */
export class StatusCarga extends Resource {
  idStatusPk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idStatusPk
  }
  set $id(val) {
    this.idStatusPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of StatusCarga
   */
  async getStatusCarga(id: number) {
    return await Request.get(`/admin/status-carga/${id}`)
      .name('getStatusCarga')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of StatusCarga
   */
  async removeStatusCarga() {
    return await Request.delete(`/admin/status-carga/${this.$id}`)
      .name('removeStatusCarga')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of StatusCarga
   */
  static async listStatusCarga(params: any) {
    return await Request.get(`/admin/status-carga`, {params})
      .name('listStatusCarga')
      .as(StatusCargaCollection)
      .getData()
  }

  /**
   * Persists a new instance of StatusCarga. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistStatusCarga() {
    return await Request.post(`/admin/status-carga`, this)
      .name('persistStatusCarga')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of StatusCarga to use it in a CSV file
   */
  static async listCsvStatusCarga(params: any) {
    return await Request.get(`/admin/status-carga/csv`, {params})
      .name('listCsvStatusCarga')
      .as(StatusCargaCollection)
      .getData()
  }
}
